import { createFileRoute } from '@tanstack/react-router';
import { resolveOrganizationRef } from '@/app/organization-ref';
import { PlatformLayout } from '@/features/shell/platform-layout';

export const Route = createFileRoute('/_app/o/$organizationId/_platform')({
    beforeLoad: ({ context, params, location }) =>
        resolveOrganizationRef(context.queryClient, params.organizationId, location),
    component: PlatformLayout,
});
